import arrow from "./images/png/arrow.png";
import Profile from "./images/png/profile.png";
import sale from "./images/png/sale.png";
import pagenotfound from "./images/png/pagenotfound.png";
import ugoLogo from "./images/png/ugoLogo.png";
import userhome from "./images/png/userhome.png";
import play from "./images/png/play.png";
import pause from "./images/png/pause.png";
import mobileuserlogo from "./images/png/mobile-userlogo.png";
import logougoout from "./images/png/logougoout.png";
import googleplay from "./images/png/googleplay.png";
import appstore from "./images/png/appstore.png";
import ugovector from "./images/png/ugo-vector.png";
import heromobile from "./images/png/heromobile.png";
import bookgbg from "./images/png/bookgbg.png";
import bookingmobile from "./images/png/bookingmobile.png";
import downloadbg from "./images/png/downloadbg.png";
import howtowork from "./images/png/howtowork.png";
import carsbg from "./images/png/carsbg.png";
import venuevoucher from "./images/png/venue-voucher.png";
import howvectortop from "./images/png/howvectortop.png";
import howvectorbottom from "./images/png/howvectorbottom.png";
import businessbg from "./images/png/businessbg.png";
import getContact from "./images/png/get-contact.png";

const Png = {
  arrow,
  Profile,
  sale,
  pagenotfound,
  ugoLogo,
  userhome,
  play,
  pause,
  mobileuserlogo,
  logougoout,
  googleplay,
  appstore,
  ugovector,
  heromobile,
  bookgbg,
  bookingmobile,
  downloadbg,
  howtowork,
  carsbg,
  venuevoucher,
  howvectortop,
  howvectorbottom,
  businessbg,
  getContact,
};

export default Png;
